const notAllowedToSolaTenants: string[] = ['bpce', 'natixis', 'devcodebashing'];

export default notAllowedToSolaTenants;
